/**
 * Rules and Knowledge Bases Hook
 * Fetches both rules and KBs from the combined endpoint for filter dropdowns
 */

import { useAtom } from 'jotai';
import { atomWithQuery } from 'jotai-tanstack-query';
import { messageService } from '@/services/message.service';

const rulesAndKbsQueryAtom = atomWithQuery(() => ({
  queryKey: ['rules-and-kbs'],
  queryFn: messageService.getRulesAndKbs
}));

export function useRulesAndKbs() {
  const [query] = useAtom(rulesAndKbsQueryAtom);
  return query;
}
